import MultiSelect from 'primevue/multiselect'
import SrInputNumber from '@/components/SrInputNumber.vue'
import { i18n } from '@/i18n'
import { markRaw } from 'vue'
import { z } from 'zod'
import { AVAILABLE_EXCHANGES } from '@/utils/consts'
import InputText from 'primevue/inputtext'
import isString from 'lodash/isString'

export function createFundingRatesFilters() {
  const { t } = i18n.global
  const swapFilters = [
    {
      header: 'exchange',
      field: 'exchanges',
      component: markRaw(MultiSelect),
      placeholder: 'Gate, Mexc, Ourbit, Lbank',
      zod: z.string().array().optional().nullable(),
      props: {
        filterMatchMode: 'startsWith',
        showClear: true,
        options: AVAILABLE_EXCHANGES,
        optionLabel: 'title',
        optionValue: 'value',
        filter: true,
        emptyFilterMessage: t('emptyMessage'),
      },
    },
    {
      field: 'symbols',
      header: 'symbols',
      component: markRaw(InputText),
      placeholder: 'BTC, BNB, ETH',
      zod: z.string().optional().nullable(),
    },
    {
      field: 'fundingMin',
      header: 'fundingRateMin',
      component: markRaw(SrInputNumber),
      placeholder: '2.00',
      zod: z.preprocess(
        (x: string | null) => (isString(x) && x.trim() === '' ? null : Number(x)),
        z.number().nullable(),
      ),
      props: {
        step: 0.0,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
    {
      field: 'fundingMax',
      header: 'fundingRateMax',
      component: markRaw(SrInputNumber),
      placeholder: '2.00',
      zod: z.preprocess(
        (x: string | null) => (isString(x) && x.trim() === '' ? null : Number(x)),
        z.number().nullable(),
      ),
      props: {
        step: 4,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
  ]
  return swapFilters
}
